import { InputAdornment } from "@mui/material";

const percentageEndAdornment = {
  InputProps: {
    endAdornment: (
      <InputAdornment position="end" sx={{ "& .MuiTypography-root": { fontSize: "14px" } }}>
        Percentage
      </InputAdornment>
    ),
  },
};

export default percentageEndAdornment;
